module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Образцы документов")]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "error"
  }, [_vm._v("\n    " + _vm._s(_vm.error.message || JSON.stringify(_vm.error, null, 2)) + "\n  ")]) : _c('form', {
    staticClass: "contract-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveSamples($event)
      }
    }
  }, [_vm._l((this.contracts), function(contract) {
    return _c('div', [_c('p', [_vm._v(_vm._s(contract.title))]), _vm._v(" "), _c('div', {
      staticClass: "upload-contract-button-container"
    }, [_c('input', {
      staticClass: "button",
      attrs: {
        "type": "file",
        "id": ("" + (contract.name)),
        "name": ("" + (contract.name))
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "uploaded-contract-link",
      attrs: {
        "target": "_blank",
        "href": ((contract.filePath) + "?p=" + (_vm.generateRandomPostfix()))
      }
    }, [_vm._v("\n          " + _vm._s(contract.filePath) + "\n        ")])])])
  }), _vm._v(" "), _c('button', {
    staticClass: "button"
  }, [_vm._v("Сохранить")])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-332d381c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Uprid/Contracts.vue
// module id = 924
// module chunks = 0